module.exports = __webpack_public_path__ + "media/images/icons/fb-c2499b29f6259ba7550b6de7bcc5d624.svg";